module.exports = __webpack_public_path__ + "img/14.13816616.jpg";